<template>
    <div id="show-table-result" class="show-table-result" v-if="dataTableservices!=null">
        <div class="show-table-result-in">
            <div class="container">
                <div class="row justify-content-center set-logo-model" v-if="dataTableservices.logo!=null || dataTableservices.photo_model!=null ">
                    <div class="col-12 col-md-5 d-flex justify-content-center align-items-center">
                        <img class="icon-logomodel" :src="dataTableservices.urlpath+dataTableservices.logo" alt="" />
                    </div>
                    <div class="col-12 col-md-5 icon-carmodel-col">
                        <img class="icon-carmodel" :src="dataTableservices.urlpath+dataTableservices.photo_model" alt="" />
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <h1 class="subscribe-title space-bt">รายการตรวจเช็กระยะ</h1>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-5 col-md-2">
                        <p class="title-head-result">รุ่นรถ</p>
                    </div>
                    <div class="col-7 col-md-8">
                        <div class="title-desc">
                            Honda {{dataHead.namemodel.name}}
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-5 col-md-2">
                        <p class="title-head-result">ปี</p>
                    </div>
                    <div class="col-7 col-md-8">
                        <div class="title-desc">
                            {{dataHead.year}}
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-5 col-md-2">
                        <p class="title-head-result">เครื่องยนต์</p>
                    </div>
                    <div class="col-7 col-md-8">
                        <div class="title-desc">
                            {{dataHead.engine}}
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-5 col-md-2">
                        <p class="title-head-result title-last">ระยะทาง</p>
                    </div>
                    <div class="col-7 col-md-8">
                        <div class="title-desc title-last">
                            {{Number(dataHead.distance).toLocaleString()}} กิโลเมตร
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-12 col-md-10">
                        <table class="table-h">
                            <col>
                            <col>
                            <thead>
                                <tr class="pd-top-bottom">
                                    <th class="s-text-title">รายการอะไหล่</th>
                                    <th class="s-text-title text-right">ราคา (บาท)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="pd-top" v-for="(dataTableserver, indexCount) in dataTableservices.dataall"
                                    :key="indexCount">
                                    <td>
                                        <p class="s-text"> {{ dataTableserver.partslist }}
                                        </p>
                                    </td>
                                    <td>
                                        <p class="s-text text-right">
                                            {{ $parent.chkText_comma(dataTableserver.coldistance) }}
                                        </p>
                                    </td>
                                </tr>
                                <template v-for="(datasum ,key, index) in dataTableservices.total">
                                    <tr :class="{'text-sum-border-top' : (index==0),'text-sum-border-bottom':(index==1),'text-sum text-sum-border-bottom border2':(index==2)}"
                                       :keyA="index" v-if="index<3">
                                        <td>
                                            <p class="s-text-title">
                                              {{ datasum.partslist }}
                                            </p>
                                        </td>
                                        <td>
                                            <p class="s-text text-right" :class="{'s-text-sum' : (index==2)}">
                                                {{ $parent.chkText_comma(datasum.coldistance) }}</p>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
                        <a class="btn btn-primary btn-arrow btn-arrow-right setbt-w first gtm-service-btn-booking" @click="serviceBookingTracking" href="https://servicebooking.honda.co.th/" target="_blank">
                            <span>นัดหมายเข้ารับบริการ</span>
                        </a>
                    </div>

                    <div class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">
                        <a class="btn-download gtm-service-btn-download" @click="downloadTracking" :href="'/service-pdf/data?id='+$parent.idModel+'&idengine='+$parent.idEngine+'&idengine='+$parent.idEngine+'&model='+dataHead.namemodel.name+'&year='+dataHead.year+'&engine='+dataHead.engine+'&distance='+dataHead.distance" target="_blank">
                            <div class="btn btn-secondary btn-arrow btn-arrow-right setbt-w">
                                <span>ดาวน์โหลด</span>
                            </div>
                        </a>
                    </div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
import moment from 'moment'
    export default {
        data() {
            return {
                sumTotol: 0,
                count: 0,
            }
        },
        props: {
            dataTableservices: {
                type: Object,
                default: null
            },
            dataHead: {
                type: Object,
                default: null
            }
        },
        methods: {
            sumtotal(value) {
                if (value == null) {
                    value = 0;
                }
                num = num + parseInt(`${value}`)
                this.sumTotol = num
            },
            serviceBookingTracking() {
                // Gtag Tracking //
                gtag('event','page periodical maintenance', { 
                    model_name: this._props.dataHead.namemodel.name,
                    action_type: 'click on page',
                    action_label: 'booking number',
                    section_name: '' 
                });
            },
            downloadTracking() {
                /// CDP Tracking ///
                analytics.track("Periodical Maintenance Download", { 
                    car_model : this._props.dataHead.namemodel.name, 
                    car_year: this._props.dataHead.year,
                    car_engine : this._props.dataHead.engine, 
                    mile: this._props.dataHead.distance,
                    ...findCarCategory(this._props.dataHead.namemodel.name),
                    created_date: moment().format("YYYY-MM-DD HH:mm:ss")
                });
                // Gtag Tracking //
                gtag('event','page periodical maintenance', { 
                    model_name: this._props.dataHead.namemodel.name,
                    action_type: 'click on page',
                    action_label: 'download periodical file',
                    section_name: '' 
                });
            }
        },
        computed: {
            sum: function () {
                let num = 0

                return function (para) {
                    this.sumTotol = 0
                    if (para == null) {
                        para = 0;
                    }
                    num = num + parseInt(`${para}`)
                    this.sumTotol = num
                    return ''
                }
            }
        },
    }

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/service/ResultModel.vue